<template>
  <div class="teaching-evaluate-apply-main">
    <div class="header">
      <div class="title">
        <span class="label">通用方案设置</span>
        <span class="extra">
          <span>通用方案将适用于全部课程，若有课程无需评教或评教内容与通用不同，请点击</span>
          <TeachingEvaluateApplyDefine v-bind="$attrs">
            <template #default="{toggleVisible}">
              <el-button size="mini"
                         type="text"
                         @click="toggleVisible">课程自定义</el-button>
            </template>
          </TeachingEvaluateApplyDefine>
        </span>
      </div>
      <div class="append">
        <el-radio-group v-model="current">
          <el-radio-button v-for="configType in configTypes"
                           :key="configType.value"
                           :label="configType.value">
            <span :class="{'theme-text': current === configType.value}">{{configType.label}}</span>
            <span v-if="current === configType.value"
                  class="tab-bar theme-bg"></span>
          </el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="main">
      <div class="main-cont">
        <keep-alive>
          <component :is="getComponent"
                     v-bind="$attrs"></component>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import TeachingEvaluateApplyDefine from './define'
import TeachingEvaluateApplyCommon from './common'
import TeachingEvaluateApplyOption from './option'
export default {
  name: 'TeachingEvaluateApplyMain',
  components: {
    TeachingEvaluateApplyDefine
  },
  data () {
    return {
      configTypes: [{
        label: '设置评教内容',
        value: '1'
      }, {
        label: '设置评教选项',
        value: '2'
      }],
      current: '1'
    }
  },
  computed: {
    getComponent () {
      switch (this.current) {
        case '1':
          return TeachingEvaluateApplyCommon
        case '2':
          return TeachingEvaluateApplyOption
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-evaluate-apply-main {
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      & > .title {
        padding: 12px 15px;
        & > .label {
          font-size: 13px;
          font-weight: bold;
        }
        & > .extra {
          margin-left: 10px;
          color: #606266;
          font-size: 12px;
          .el-button {
            padding: 0;
          }
        }
      }
      & > .append {
        text-align: center;
        background-color: #f9f9fa;
        .el-radio-group {
          .el-radio-button {
            .el-radio-button__inner {
              position: relative;
              color: #303133;
              font-size: 13px;
              padding: 16px 20px;
              box-shadow: none!important;
              background-color: transparent!important;
              border: none!important;
              span {
                transition: all .3s;
              }
              .tab-bar {
                position: absolute;
                left: 50%;
                bottom: 0;
                width: 30px;
                height: 2px;
                margin-left: -15px;
                animation: tabBar .3s forwards;
              }
              @keyframes tabBar {
                from {
                  opacity: .5;
                  transform: translateY(100%);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }
            }
          }
        }
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
</style>
